$(document).ready(function () {
  $.fn.datepicker.defaults.format = "dd/mm/yyyy";
  $.fn.datepicker.defaults.autoclose = true;
  $.fn.datepicker.defaults.startDate = new Date();

  var cross =
    "<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>\
  			<path fill='#0E41A6' fill-rule='evenodd' d='M11.7781746,10.363961 L6.12132034,4.70710678 C5.73079605,4.31658249 5.09763107,4.31658249 4.70710678,4.70710678 L4.70710678,4.70710678 L4.70710678,4.70710678 C4.31658249,5.09763107 4.31658249,5.73079605 4.70710678,6.12132034 L4.70710678,6.12132034 L10.363961,11.7781746 L4.70710678,17.4350288 C4.31658249,17.8255531 4.31658249,18.4587181 4.70710678,18.8492424 C5.09763107,19.2397667 5.73079605,19.2397667 6.12132034,18.8492424 L11.7781746,13.1923882 L17.4350288,18.8492424 C17.8255531,19.2397667 18.4587181,19.2397667 18.8492424,18.8492424 C19.2397667,18.4587181 19.2397667,17.8255531 18.8492424,17.4350288 L13.1923882,11.7781746 L18.8492424,6.12132034 L18.8492424,6.12132034 C19.2397667,5.73079605 19.2397667,5.09763107 18.8492424,4.70710678 L18.8492424,4.70710678 L18.8492424,4.70710678 C18.4587181,4.31658249 17.8255531,4.31658249 17.4350288,4.70710678 L11.7781746,10.363961 Z'></path>\
				</svg>";

  $("#rate_manager__end-datepicker").change(function (e) {
    //Append a new row of code to the "#multiple-range-dates" div
    if (document.getElementById("input_start_date").value.length != 0) {
      createDateRanges();
    }
    $("#number_date_ranges").val(numberOfSavedRanges);
  });

  $("#rate_manager__start-datepicker").change(function (e) {
    //Append a new row of code to the "#multiple-range-dates" div
    if (document.getElementById("input_end_date").value.length != 0) {
      createDateRanges();
    }
    $("#number_date_ranges").val(numberOfSavedRanges);
  });

  // Specific case for block room modal, to allow selecting dates from the past
  $("#block_room_start_date").datepicker({
    startDate: -Infinity,
  });

  // Specific case for block room modal, to allow selecting dates from the past
  $("#block_room_end_date").datepicker({
    startDate: -Infinity,
  });

  createDateRanges = function () {
    numberOfSavedRanges += 1;
    var startDate = document.getElementById("input_start_date").value;
    var endDate = document.getElementById("input_end_date").value;

    var separation = "<hr class='rate_manager__separation-date-ranges'>";
    var secondInputDateRange =
      "<div class='rate_manager__selected-range'>" +
      separation +
      "<div class='hide-element'><input type='text' name='start-date-" +
      numberOfSavedRanges +
      "' value=" +
      startDate +
      "></div> \
								  <div class='hide-element'><input type='text' name='end-date-" +
      numberOfSavedRanges +
      "' value=" +
      endDate +
      "></div> \
								  <div class='rate_manager__multiple_ranges'> <div class='size0'>" +
      startDate +
      " - " +
      endDate +
      "</div> <div class='delete u-cursor-pointer'> " +
      cross +
      "</div></div></div>";

    var firstInputDateRange =
      "<div class='rate_manager__selected-range'><div class='hide-element'><input type='text' name='start-date-" +
      numberOfSavedRanges +
      "' value=" +
      startDate +
      "></div> \
								  <div class='hide-element'><input type='text' name='end-date-" +
      numberOfSavedRanges +
      "' value=" +
      endDate +
      "></div> \
								  <div class='rate_manager__multiple_ranges'> <div class='size0'>" +
      startDate +
      " - " +
      endDate +
      "</div> <div class='delete u-cursor-pointer'> " +
      cross +
      "</div></div></div>";
    var finalInput;

    if (numberOfSavedRanges > 1) {
      finalInput = secondInputDateRange;
    } else {
      finalInput = firstInputDateRange;
    }

    $("#multiple-range-dates").append(finalInput);
    $("#input_start_date").val("");
    $("#input_end_date").val("");
  };

  $("body").on("click", ".delete", function (e) {
    $(this).closest(".rate_manager__selected-range").remove();
  });
});
